import { render, staticRenderFns } from "./AllTweets.vue?vue&type=template&id=814eb73c&scoped=true"
import script from "./AllTweets.vue?vue&type=script&lang=js"
export * from "./AllTweets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814eb73c",
  null
  
)

export default component.exports